import { Fragment, useState } from "react";
import { sentenceCase } from "change-case-all";
import { FaCircleExclamation } from "react-icons/fa6";
import { Sync, ToggleOffOutlined, ToggleOnOutlined } from "@mui/icons-material";
import {
  Checkbox,
  Grid,
  IconButton,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";

import { useAxios } from "../../../hooks";
import { Paper } from "../../../components";
import languageTranslator from "../../../utils/languageTranslator";
import { ActiveTextEighteen, colors } from "../../css components/Style";
import LockCampaignDialog from "./campaign form components/LockCampaignDialog";
import { useSelector } from "react-redux";

export default function AdminCampaignStatus({ formikProps }) {
  const axios = useAxios();
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState("en");
  const [dialogState, setDialogState] = useState({ data: {}, state: false });

  const { activeBrand } = useSelector((state) => state.memberDetails);
  return (
    <Fragment>
      <Paper>
        {(formikProps.values.displayMessage ===
          "The request has been raised to the required partners. Please wait." ||
          formikProps.values.displayMessage ===
            "Campaign will be able to launch on start date.") && (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              width: "100%",
              paddingTop: "10px",
            }}
          >
            <Typography>EN</Typography>
            <Checkbox
              style={{
                padding: "3px 9px",
                position: "relative",
                top: "-9px",
              }}
              onChange={(e) => {
                if (e.target.checked) {
                  setLanguage("id");
                } else {
                  setLanguage("en");
                }
              }}
              icon={<ToggleOffOutlined fontSize="large" />}
              checkedIcon={
                <ToggleOnOutlined fontSize="large" style={{ color: "red" }} />
              }
            />
            <Typography>ID</Typography>
          </div>
        )}

        {formikProps.values.displayMessage && (
          <Grid item xs={12} textAlign={"center"} display={"flex"}>
            <ActiveTextEighteen
              style={{
                color: colorPicker(),
              }}
            >
              {formikProps.values.displayMessage ===
                "The request has been raised to the required partners. Please wait." ||
              formikProps.values.displayMessage ===
                "Campaign will be able to launch on start date."
                ? languageTranslator(
                    formikProps.values.displayMessage,
                    language
                  )
                : formikProps.values.displayMessage}
            </ActiveTextEighteen>
          </Grid>
        )}

        <Grid item xs={12} textAlign={"center"} display={"flex"}>
          <ActiveTextEighteen
            style={{
              color: colorPicker(),
            }}
          >
            {!loading ? (
              formikProps.values.campaign_status === "READY" ? (
                parseInt(formikProps?.values?.Intersection_Audience) > 0 &&
                sentenceCase(formikProps.values.campaign_status)
              ) : (
                sentenceCase(formikProps.values.campaign_status)
              )
            ) : (
              <Skeleton
                variant="rectangular"
                style={{ padding: "3px" }}
                width={"fit-content"}
              >
                {" "}
                Fetching Status
              </Skeleton>
            )}

            {formikProps.values.campaignID &&
              (formikProps.values?.campaign_status === "CREATED" ||
                formikProps.values?.campaign_status === "REQUESTED") &&
              !loading && (
                <Tooltip title="Click to check latest status">
                  <IconButton
                    style={{ padding: "3px", color: colors.error }}
                    onClick={() => handleStatus()}
                  >
                    <Sync />
                  </IconButton>
                </Tooltip>
              )}
          </ActiveTextEighteen>
        </Grid>

        <Grid item xs={12} style={{ justifyContent: "end", padding: "0 16px" }}>
          {formikProps.values.campaignID &&
            formikProps.values?.campaign_status !== "CREATED" &&
            formikProps.values?.campaign_status !== "REQUESTED" &&
            formikProps.values?.missedParameter?.length > 0 && (
              <Typography color={colors.error}>
                <Typography
                  onClick={handleMissedParam}
                  variant="button"
                  style={{ cursor: "pointer", color: colors.info }}
                >
                  CLICK
                </Typography>{" "}
                to view the current status of the requested attributes.{" "}
              </Typography>
            )}
        </Grid>
      </Paper>

      <LockCampaignDialog
        dialogState={dialogState}
        setDialogState={setDialogState}
        formikProps={formikProps}
      />
    </Fragment>
  );

  function handleMissedParam() {
    setDialogState({
      state: true,
      data: formikProps.values,
      component: "params",
    });
  }

  function handleStatus() {
    setLoading(true);
    axios({
      url:
        "/user/brand/getCampaign?brandId=" +
        parseInt(activeBrand.ID) +
        "&campaignId=" +
        parseInt(formikProps.values.campaignID),
      disableRedirect: true,
    }).then(function (response) {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          campaign_status: response.data.campaign_status,
        }));
        setLoading(false);
      }
    });
  }

  function colorPicker() {
    let color;
    if (
      formikProps.values.campaign_status === "REQUESTED" ||
      formikProps.values.campaign_status === "CREATED"
    ) {
      color = colors.yellow;
    }

    if (
      formikProps.values.campaign_status === "OFFER_ACCEPTED" ||
      formikProps.values.campaign_status === "ACTIVE" ||
      formikProps.values.campaign_status === "ACCEPTED" ||
      formikProps.values.campaign_status === "PARTIAL_ACCEPTED"
    ) {
      color = colors.green;
    }

    if (formikProps.values.campaign_status === "INITIATED") {
      color = colors.initiated;
    }

    if (
      formikProps.values.campaign_status === "REJECTED" ||
      formikProps.values.campaign_status === "FAILED" ||
      formikProps.values.campaign_status === "PARTIAL_REJECTED" ||
      formikProps.values.campaign_status === "INTERRUPTED"
    ) {
      color = colors.error;
    }
    if (formikProps.values.campaign_status === "Expired") {
      color = "#bdbdbd";
    }
    if (formikProps.values.campaign_status === "COMPLETED") {
      color = "#2f8632";
    }
    if (formikProps.values.campaign_status === "READY") {
      color = colors.success;
    }

    if (
      formikProps.values.campaign_status === "READY" &&
      parseInt(formikProps.values.Intersection_Audience) === 0
    ) {
      color = colors.error;
    }

    return color;
  }
}
